import { Flex, Image, Tooltip } from "@chakra-ui/react";
import { ClickableOverlay } from "../ClickableOverlay";

interface FileEntry {
  fileName: string;
  altText: string;
}

const filesInOrder: FileEntry[] = [
  {
    fileName: "buns-in-sun",
    altText: "cat boy on stomach in field of flowers",
  },
  {
    fileName: "strawberries",
    altText: "stressed looking girl observes strawberry shortcake",
  },
  {
    fileName: "bunny-angel",
    altText: "bunny angel looks over pink haired girl",
  },
  {
    fileName: "feeling-bonita",
    altText: "cat boy with fabulous nails feels bonita",
  },
  { fileName: "contained", altText: "doll faced girl stares vacantly" },
  { fileName: "death", altText: "cat boy ponders mortality" },
  { fileName: "waiting", altText: "cat boy is tired of waiting" },
  { fileName: "annoying", altText: "cat boy is annoyed" },
  { fileName: "the_fates", altText: "angels weep over terrible outcome" },
  { fileName: "too_loud", altText: "ears assailed and impaled" },
  { fileName: "crowded_mind", altText: "crowded and bustling" },
  { fileName: "cheeky_chu", altText: "cheeky. what does she want?" },
  { fileName: "spaced", altText: "a thousand mile stare" },
];

export const WigglyPaint: React.FC = () => {
  return (
    <Flex
      rowGap={22}
      gap={2}
      flexWrap="wrap"
      m="0px auto"
      justifyContent="center"
    >
      {filesInOrder.map((file) => (
        <ClickableOverlay key={file.fileName} label={file.altText}>
          <Image
            maxW="300px"
            //_hover={{ border: "2px solid #4895ef", borderRadius: "25px" }}
            alt={file.altText}
            src={`/wigglypaint/${file.fileName}.gif`}
            padding={5}
          />
        </ClickableOverlay>
      ))}
    </Flex>
  );
};
